import React, { useEffect } from "react";
import noPermissionImg from "assets/permission.png";
import { useNavigate } from "react-router-dom";
import { useUserContext } from "features/users";
const LayoutView: React.FC = () => {
   
const navigate = useNavigate();
  const { user }: any = useUserContext();

  useEffect(() => {
    if (!user?.rolePermission?.length) return;

    // ✅ check if user has AT LEAST ONE view permission
    const hasAnyViewPermission = user.rolePermission.some(
      (menu: any) => menu.permissions.view === true
    );

    // 🔥 if view is true → go dashboard
    if (hasAnyViewPermission) {
      navigate("/dashboard", { replace: true });
    }
  }, [user, navigate]);
  
  return (
    <div
      style={{
        position: "relative",
           height: "calc(100vh - 92px)",
        width: "100%",
        overflow: "hidden",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      {/* ====== Center Card ====== */}
      <div
        style={{
          textAlign: "center",
          background: "white",
          padding: "20px",
          borderRadius: 16,
          boxShadow: "0px 8px 25px rgba(0,0,0,0.12)",
          zIndex: 10,
          width: 400,
        }}
      >
        <img
          src={noPermissionImg}
          alt="No Permission"
          style={{ width: 100, marginBottom: 5 }}
        />

        <h2 style={{ marginBottom: 10, color: "#111", fontSize: 26 }}>
          No Permission
        </h2>

        <p
          style={{
            color: "#666",
            fontSize: 16,
            maxWidth: 350,
            margin: "0 auto 25px",
            lineHeight: 1.5,
          }}
        >
          You do not have permission to access this page.
          Please contact admin to enable permissions.
        </p>

        
      </div>
    </div>
  );
};

export default LayoutView;
